import TextareaWithCharacterCount from './TextareaWithCharacterCount';

export default TextareaWithCharacterCount;
